import React, { Component } from 'react'
import { runVerificaAutenticacao } from '../../../services/api';
import Header from './../../../components/Header/index';
import ComponentFlexInput from './components/ComponentFlexInput';
import * as S from "./styles";


const IconUpload = "/images/icon_upload_boleto.svg";
class UploadBoleto extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dados: [],
      loading: false,
    }
  }
  componentDidMount() {
    runVerificaAutenticacao();
  }

  render() {


    return (
      <S.ContainerUploadBoleto >
        <S.FinanceiroContainerText>
          <h1>
            <strong>UPLOAD DO BOLETO</strong>
          </h1>
        </S.FinanceiroContainerText>
        <S.ImageIconUpload src={IconUpload} />
        <ComponentFlexInput />
      </S.ContainerUploadBoleto>
    )
  }
}

export default UploadBoleto